import { render, staticRenderFns } from "./DomainOppositionOwnerForm.vue?vue&type=template&id=70102873&"
import script from "./DomainOppositionOwnerForm.vue?vue&type=script&lang=js&"
export * from "./DomainOppositionOwnerForm.vue?vue&type=script&lang=js&"
import style0 from "./DomainOppositionOwnerForm.vue?vue&type=style&index=0&id=70102873&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports